/**
 * Affiliati: persist the utm_content token for the session so the affiliate
 * attribution survives navigation. Moved out of layout/theme.liquid (inline) so
 * it is cached as a versioned asset.
 */
document.addEventListener('DOMContentLoaded', function () {
	const params = new URLSearchParams(window.location.search);
	const utmContent = params.get('utm_content');
	if (utmContent) {
		sessionStorage.setItem('affiliati_utm_content_token', utmContent);
	}
});
